import {
  DataGridFilters,
  DataGridFilter,
  DataGridOptions,
} from "fe-shared/src/components/DataGrid/modules/types";

import {
  TransferResponse,
  TransferListItem,
  DataGridRequestParams,
  DataGridFiltersParams,
  TransferStatus,
} from "../types";
import { ADJUSTABLE_SUBMITTED_STATUS } from "./transfersGridConfig";

export const PROPERTY_NAMES_MAP: { [key: string]: string } = {
  transferNumber: "transferOrInvoiceNumber",
};

const getPropertyName = (name: string) => PROPERTY_NAMES_MAP[name] || name;

export const getTransfersArray = (data?: TransferResponse[]) => {
  return data?.reduce(
    (acc: TransferListItem[], element: TransferResponse) =>
      acc.concat(element.transfers),
    []
  );
};

const getFilterValues = (filter: DataGridFilter) => {
  switch (filter.type) {
    case "dateRangeFilter": {
      const [startDate, endDate] = filter.value;

      if (startDate) {
        return [startDate, endDate || startDate]
          .map((date) => new Date(date).toJSON())
          .join(",");
      }
      return "";
    }
    case "selectFilter":
      if (filter.value.length) {
        return filter.value.join(",");
      }
      return "";
    default:
      return filter.value;
  }
};

export const getRequestParams = (
  filters: DataGridFilters,
  options: DataGridOptions
): DataGridRequestParams => {
  return {
    filteringParameters: Object.keys(filters).reduce(
      (acc: DataGridFiltersParams[], property: string) => {
        const filter = filters[property];
        const values = getFilterValues(filter);
        const propertyName = getPropertyName(property);

        if (
          property === "statusCode" &&
          [ADJUSTABLE_SUBMITTED_STATUS, TransferStatus.Submitted].includes(
            values
          )
        ) {
          acc.push(
            {
              propertyName,
              values: TransferStatus.Submitted,
            },
            {
              propertyName: "isAdjustable",
              values: values === ADJUSTABLE_SUBMITTED_STATUS ? "true" : "false",
            }
          );
        } else if (property === "transferNumber") {
          const currentNumber = values.replace(/[# ]/g, "");

          if (currentNumber) {
            acc.push({
              propertyName,
              values: currentNumber,
            });
          }
        } else if (values) {
          acc.push({
            propertyName,
            values,
          });
        }
        return acc;
      },
      []
    ),
    sortingBy: {
      propertyName: options.sortField,
      isAscending: options.sortDirection === "asc",
    },
  };
};
